import { supabase } from "./client";

/** Returns a Supabase client scoped to the shared `sales` schema. */
export const salesDb = () => (supabase as any).schema("sales");